import { NavLink } from 'react-router-dom';
import '../global.css';

export const Nav = () => {
	return (
		<nav>
			<NavLink className={({ isActive }) => (isActive ? 'active' : '')} to="/override">
				Search/Translation Overrides
			</NavLink>
			<NavLink className={({ isActive }) => (isActive ? 'active' : '')} to="/lookup">
				Product/Category lookup
			</NavLink>
			<NavLink
				className={({ isActive }) => (isActive ? 'active' : '')}
				to="/manual-translation"
			>
				Review translation problem cases
			</NavLink>
			<NavLink className={({ isActive }) => (isActive ? 'active' : '')} to="/bulk-search">
				Bulk search
			</NavLink>
			<NavLink className={({ isActive }) => (isActive ? 'active' : '')} to="/bulk-import">
				Bulk import
			</NavLink>
			<a className="nav-link" href="/api/docs">API docs</a>
			<button onClick={logoutUser}>Logout</button>
		</nav>
	);
};

function logoutUser() {
	localStorage.clear();
	window.location.href = '/';
}
